import { Column, FMColumn } from '../model';
import { TagsCell } from '../components/cells/TagsCell';
import { FilterEnumContainer } from '../components/plugins/filters/FilterEnumContainer';
import { Type } from '../../../../general/modules/filter/dataModel';

// Имена тегов строки в алфавитном порядке для подписи. Порядок фиксируем сами,
// потому что бэкенд отдаёт теги в порядке добавления.
const sortedTagNames = (tags: { name: string }[] | undefined) =>
  (tags ?? []).map((tag) => tag.name).sort((a, b) => a.localeCompare(b));

export const tagsCol: FMColumn<Type.ID> = {
  key: Column.tags,
  dataKey: Column.tags,
  title: 'Tags',
  // В заголовке только воронка фильтра: сортировка по набору тегов не имеет смысла.
  // Ширина — впритык под заголовок: «Tags» (~32px) + кнопка фильтра 24px
  // + падинги ячейки small-таблицы 2 × 8px + бордер.
  width: 74,
  sortable: false,
  cellRenderer: TagsCell,
  className: 'ch-file-manager__cell_tags',
  filter: Type.ID,
  plugins: [FilterEnumContainer],
  getter: (row) => sortedTagNames(row.tags).join(', '),
  // Фильтр проходит, если у строки есть хотя бы один из выбранных тегов.
  multiGetter: (row) => (row.tags ?? []).map((tag) => tag.id),
  multiOptions: (row) => (row.tags ?? []).map((tag) => ({ id: tag.id, title: tag.name })),
  toDisplayString: (row) => {
    const names = sortedTagNames(row.tags);
    return names.length > 0 ? names.join(', ') : null;
  },
};
